import * as React from 'react';
import {AmazonListing, amazonListingsApi, Tables} from 'cl-api';
import {store} from '../../../App/store';
import {clearTaskProgress} from '../../../MyAccount/ViewDesigns/redux/modules/general';
import {getCurrentState} from '../EbayListingsActions/currentState';
import {getAmazonSellerNameById} from '../../../Layout/MyAccountLayout/ApplicationLayoutSelectors';

export function syncSellerListings(
  sellerId: string,
  importProps = {createProducts: false, ignoreInactive: false, sitePriorities: null}
) {
  let activityMeta;
  if (importProps.createProducts) {
    const sellerName = getAmazonSellerNameById(getCurrentState(), sellerId);
    store.dispatch(clearTaskProgress(Tables.InventoryTable));
    activityMeta = {
      sourceType: 'Amazon',
      sourceName: sellerName,
      refresh: [Tables.InventoryTable, Tables.ImportTable],
      task: Tables.InventoryTable,
    };
  } else {
    store.dispatch(clearTaskProgress(Tables.AmazonListingsTable));
    activityMeta = {
      task: Tables.AmazonListingsTable,
      refresh: [Tables.AmazonListingsTable],
      sourceType: 'Sync From Amazon',
      sourceName: 'Sync From Amazon',
    };
  }
  return amazonListingsApi.syncListings(sellerId, {activityMeta, importProps});
}

export async function createNewListings(
  body: {objects: AmazonListing[]; site: string},
  sellerId: string
): Promise<any> {
  try {
    return await amazonListingsApi.createNewListing(body, sellerId, {credentials: 'include'});
  } catch (e) {
    if (e.json) {
      return e.json();
    }
    return e;
  }
}
